import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const DIJON = [47.322, 5.0415];
const RADIUS_M = 24000; // ~24 km

const COMMUNES = [
  { name: "Dijon", coords: [47.322, 5.0415], main: true },
  { name: "Is-sur-Tille", coords: [47.5147, 5.1017] },
  { name: "Messigny-et-Vantoux", coords: [47.4203, 5.0603] },
  { name: "Arc-sur-Tille", coords: [47.3253, 5.1561] },
  { name: "Genlis", coords: [47.2417, 5.2158] },
  { name: "Thorey-en-Plaine", coords: [47.1897, 5.1436] },
  { name: "Nuits-Saint-Georges", coords: [47.1383, 4.9497] },
  { name: "Gevrey-Chambertin", coords: [47.2258, 4.9686] },
  { name: "Marsannay-la-Côte", coords: [47.2686, 4.9942] },
  { name: "Malain", coords: [47.3225, 4.802] },
  { name: "Fleurey-sur-Ouche", coords: [47.3086, 4.8686] },
  { name: "Talant", coords: [47.336, 4.9981] },
  { name: "Chenôve", coords: [47.29, 5.01] },
  { name: "Fontaine-lès-Dijon", coords: [47.3389, 5.0197] },
  { name: "Longvic", coords: [47.2903, 5.0672] },
  { name: "Chevigny-Saint-Sauveur", coords: [47.3011, 5.1319] },
  { name: "Quetigny", coords: [47.3111, 5.1069] },
  { name: "Ahuy", coords: [47.3572, 5.0308] },
];

export default function MapZone() {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || mapRef.current) return;

    const map = L.map(el, {
      center: DIJON,
      zoom: 10,
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true,
    });
    mapRef.current = map;

    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      maxZoom: 19,
    }).addTo(map);

    L.circle(DIJON, {
      radius: RADIUS_M,
      color: "#BA8E82",
      weight: 2,
      fillColor: "#D2A69A",
      fillOpacity: 0.15,
      dashArray: "6 8",
    }).addTo(map);

    COMMUNES.forEach((c) => {
      const isMain = c.main;
      const marker = L.circleMarker(c.coords, {
        radius: isMain ? 9 : 5,
        color: isMain ? "#4A403A" : "#BA8E82",
        weight: 2,
        fillColor: isMain ? "#4A403A" : "#FAF7F2",
        fillOpacity: 1,
      }).addTo(map);
      marker.bindTooltip(c.name, {
        direction: "top",
        className: "lea-map-label",
        offset: [0, -6],
      });
    });

    const t = setTimeout(() => {
      if (mapRef.current) mapRef.current.invalidateSize();
    }, 250);

    return () => {
      clearTimeout(t);
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="zone-map"
      className="w-full h-[480px] rounded-3xl overflow-hidden border border-[#E5DCD6] shadow-softer z-0"
      style={{ background: "#F4EBE6" }}
    />
  );
}
